export enum StyleValuesEnum {
  Abstraction = 'abstraction', // Abstrakcja
  Modernism = 'modernism', // Modernizm
  FigurativeArt = 'figurativeArt', // Sztuka figuratywna
  Surrealism = 'surrealism', // Surrealizm
  Hyperrealism = 'hyperrealism', // Hiperrealizm
  PopArt = 'popArt', // Pop art
  Expressionism = 'expressionism', // Ekspresjonizm
  Realism = 'realism', // Realizm
  Cubism = 'cubism', // Kubizm
  Impressionism = 'impressionism', // Impresjonizm
  SocialistRealism = 'socialistRealism', // Socrealizm
  Primitivism = 'primitivism', // Prymitywizm
  MagicRealism = 'magicRealism', // Realizm magiczny
  Academism = 'academism', // Akademizm
  Ethno = 'ethno', // Etno
  StreetArt = 'streetArt', // Street art
  ArtDeco = 'artDeco', // Art deco
  Minimalism = 'minimalism', // Minimalizm
  Symbolism = 'symbolism', // Symbolizm
  Eclecticism = 'eclecticism', // Eklektyzm
  Other = 'other' // Inny
}
